/*
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  NAWIGACJA PANELU RESTAURACJI — OSOBNA OD MAPY CONTROL CENTER
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *
 *  ┌─ DLACZEGO OSOBNY PLIK, A NIE FILTR NA `workspaces.ts` ─────────────────────────────────────┐
 *  │ Filtrowana lista jest listą WSZYSTKIEGO plus warunkiem. Wystarczy, że ktoś doda pozycję    │
 *  │ bez uprawnienia albo poluzuje warunek — i w panelu najemcy pojawia się Administracja.      │
 *  │ Widać to dopiero na zrzucie ekranu od właściciela, czyli za późno.                          │
 *  │                                                                                             │
 *  │ Tutaj lista jest ZAMKNIĘTA. Nie da się „przepuścić" pozycji administracyjnej, bo jej tu    │
 *  │ po prostu nie ma. Dołożenie czegokolwiek wymaga edycji tego pliku, a to widać w przeglądzie.│
 *  └─────────────────────────────────────────────────────────────────────────────────────────────┘
 *
 *  I ZDANIE, KTÓREGO NIE WOLNO STRACIĆ Z OCZU: to jest wygoda, nie zabezpieczenie. Granicą jest
 *  `granicaNajemcy` po stronie serwera — ręcznie wpisany adres administracyjny kończy się tam
 *  odmową, niezależnie od tego, co jest w tym pliku.
 */

export interface PozycjaPanelu {
  id: string;
  /** Ścieżka WZGLĘDEM `/restauracja`. Pusty ciąg = ekran domyślny. */
  sciezka: string;
  etykieta: string;
  opis: string;
}

export const POZYCJE_PANELU: readonly PozycjaPanelu[] = [
  {
    id: 'dzisiaj',
    sciezka: '',
    etykieta: 'Dzisiejsze zamówienia',
    opis: 'Co i ile ugotować, i do której szkoły to jedzie.',
  },
  {
    id: 'dania',
    sciezka: 'dania',
    etykieta: 'Dania / Posiłki',
    opis: 'Karta dań restauracji. Każda zmiana przechodzi przez moderację.',
  },
  {
    id: 'menu',
    sciezka: 'menu',
    etykieta: 'Menu',
    opis: 'Menu w szkołach już przypisanych do restauracji.',
  },
  {
    id: 'szkoly',
    sciezka: 'szkoly',
    etykieta: 'Szkoły',
    opis: 'Tylko do odczytu. Przypisania nadaje administracja.',
  },
  {
    id: 'transakcje',
    sciezka: 'transakcje',
    etykieta: 'Historia transakcji',
    opis: 'Sprzedane pozycje. Wartość katalogowa, nie rozliczenie.',
  },
  {
    id: 'raporty-dostaw',
    sciezka: 'raporty-dostaw',
    etykieta: 'Raporty dostaw',
    opis: 'Punktualność, kierowcy i zgłoszenia spóźnień — dla tej restauracji.',
  },
];

/** Korzeń panelu. Trzymany w jednym miejscu, bo pojawia się i w trasach, i w odnośnikach. */
export const KORZEN_PANELU = '/restauracja';

export function sciezkaPozycji(p: PozycjaPanelu): string {
  return p.sciezka ? `${KORZEN_PANELU}/${p.sciezka}` : KORZEN_PANELU;
}

/*
 * ┌─ CZEGO W TYM PANELU NIE MA — SPIS JAWNY, ŻEBY DAŁO SIĘ GO SPRAWDZIĆ TESTEM ─────────────────┐
 * │ Lista nie służy do niczego w czasie działania. Istnieje po to, żeby test regresji miał czego │
 * │ szukać w wyrenderowanej powłoce — a zrzut ekranu, który zgłosił właściciel, stał się         │
 * │ niemożliwy do powtórzenia dla prawdziwej sesji restauracji.                                  │
 * └──────────────────────────────────────────────────────────────────────────────────────────────┘
 */
export const NIEOBECNE_W_PANELU: readonly string[] = [
  'Administracja',
  'Użytkownicy',
  'Organizacja',
  'Grafik',
  'Moderacja menu',
  'CRM',
  'Restauracje',
  'Sprzedaż wg szkół',
  'Transakcje',
  'Opinie',
  'Insighty',
  'Panele',
  'Podgląd restauracji',
  'Przestrzeń Dostaw',
];
